module.exports = __webpack_public_path__ + "img/icon_facharzt_iso.9b5d3e4f.svg";